import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDDJJ } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { useParams } from "react-router"
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF from '../../components/ReactPDF/ReactPDF'





const AdminDDJJ = () => {

  const token = localStorage.getItem('token')
  const {userId} = useParams()


  
  const ddjj = useSelector(state => state.ddjj)

  
  const dispatch = useDispatch()

  useEffect(()=>{ 
    dispatch(getDDJJ(userId, token))
  }, [dispatch, token, userId])

   
  return (
     <div>
      <PDFViewer style={{ width: '100%', height: '100vh'}}>
        <ReactPDF props={ddjj} />
      </PDFViewer>
     </div>
  );
}

export default AdminDDJJ


